const carouselItems = [
  {
    image: "https://readdy.ai/api/search-image?query=A%20grand%20ancient%20Chinese%20palace%20scene%20with%20flowing%20red%20silk%20banners%20and%20golden%20dragon%20decorations%2C%20dramatic%20cinematic%20lighting%2C%20imperial%20court%20atmosphere%2C%20rich%20crimson%20and%20gold%20color%20scheme%2C%20epic%20scale%20composition%2C%20high%20production%20value%20aesthetic%2C%20no%20text&width=900&height=500&seq=tomato-carousel-01&orientation=landscape",
    title: '古装大戏《锦绣芳华》',
    tag: '热播中',
    desc: '年度最受期待古装传奇巨制，精美服化道震撼全网，每日更新两集，追剧党必看。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20dark%20mysterious%20alleyway%20at%20night%20with%20a%20single%20streetlamp%20casting%20long%20shadows%2C%20film%20noir%20detective%20vibe%2C%20wet%20cobblestones%2C%20moody%20atmosphere%20with%20deep%20blacks%20and%20warm%20highlights%2C%20suspense%20thriller%20cinematic%20style%2C%20no%20text&width=900&height=500&seq=tomato-carousel-02&orientation=landscape",
    title: '悬疑剧场：《暗夜追凶》',
    tag: '豆瓣8.9',
    desc: '12集精品悬疑短剧，全员演技在线，每集结尾高能反转让人欲罢不能，烧脑爱好者首选。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20futuristic%20spaceship%20bridge%20with%20holographic%20star%20maps%20and%20glowing%20control%20panels%2C%20view%20of%20colorful%20nebula%20through%20large%20window%2C%20sci-fi%20atmosphere%2C%20clean%20modern%20design%20with%20warm%20ambient%20lighting%2C%20cinematic%20wide%20angle%20composition%2C%20no%20text&width=900&height=500&seq=tomato-carousel-03&orientation=landscape",
    title: '科幻巨制：《星际迷航：新纪元》',
    tag: '独家上线',
    desc: '好莱坞级视觉效果，硬核科幻设定搭配人性思考，今夏最值得看的科幻剧集。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20beautiful%20cherry%20blossom%20tree%20lined%20path%20in%20spring%2C%20soft%20pink%20petals%20falling%2C%20two%20people%20walking%20in%20the%20distance%2C%20warm%20golden%20hour%20sunlight%2C%20romantic%20and%20peaceful%20atmosphere%2C%20Korean%20drama%20aesthetic%20with%20dreamy%20soft%20focus%2C%20no%20text&width=900&height=500&seq=tomato-carousel-04&orientation=landscape",
    title: '韩剧精选：《那年樱花季》',
    tag: '催泪神作',
    desc: '年度最高分韩剧，细腻情感打动千万观众，准备好纸巾，每一集都是泪点暴击。',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600">当下最值得关注的精选剧集</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                  width="900"
                  height="500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none"></div>
              </div>
              <div className="p-5 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
                <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                  <span>立即观看</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}